import { differenceInDays } from 'date-fns';
import { IS_AUTO_TEST_HIDE } from 'reactApp/appHelpers/configHelpers';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { paidUserReturnAB, paidUserReturnPromoSettings } from 'reactApp/appHelpers/featuresHelpers/features/paidUserReturnAB';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { loadPaidInfoRequest } from 'reactApp/modules/paidInfo/paidInfo.module';
import { handlePaidInfoSuccess } from 'reactApp/modules/paidInfo/paidInfo.saga';
import { PaidInfoSelectors } from 'reactApp/modules/paidInfo/paidInfo.selectors';
import { pastSubscriptionsRequest } from 'reactApp/modules/pastSubscriptions/pastSubscriptions.module';
import { handlePastSubscriptionsSuccess } from 'reactApp/modules/pastSubscriptions/pastSubscriptions.saga';
import { PastSubscriptionsSelectors } from 'reactApp/modules/pastSubscriptions/pastSubscriptions.selectors';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store } from 'reactApp/store';
import { closePaidUserReturnModal, renderPaidUserReturnModal } from 'reactApp/ui/PaidUserReturnModal/PaidUserReturnModal.helper';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { getDays } from 'reactApp/utils/Period';
import { put, select } from 'typed-redux-saga';

const PAID_USER_RETURN_PROMO_ID = 'paid-user-return-promo-id';

export function* initPaidUserReturnModal() {
    const storage = yield* select(getCurrentStorage);
    const { isHome } = getStorage(storage);
    const isMobile = yield* select(EnvironmentSelectors.isMobile);
    const isPaid = yield* select(UserSelectors.isPaidUser);
    const isCorpUser = yield* select(UserSelectors.isCorpUser);
    const isBizUser = yield* select(UserSelectors.isBizUser);
    const isSocialUser = yield* select(UserSelectors.isSocialUser);

    const daysCount = getDays(paidUserReturnPromoSettings.period);
    const periodPassed = storeHelper.getValue(PAID_USER_RETURN_PROMO_ID) && storeHelper.isPassed(PAID_USER_RETURN_PROMO_ID, { daysCount });

    if (periodPassed) {
        storeHelper.clearStore(PAID_USER_RETURN_PROMO_ID);
    }

    // показываем на /home и просмотрщике
    // скрываем если фича выключена
    // не показывается платникам
    // скрываем на автотестых и таче
    // исключаем платников, корпов, бизов и соцников
    // исключаем если период еще не прошел для показа
    if (
        !isHome ||
        !paidUserReturnAB.enabled ||
        isMobile ||
        IS_AUTO_TEST_HIDE ||
        isPaid ||
        isCorpUser ||
        isBizUser ||
        isSocialUser ||
        storeHelper.getValue(PAID_USER_RETURN_PROMO_ID)
    ) {
        return;
    }

    yield put(loadPaidInfoRequest());
    yield handlePaidInfoSuccess();
    const isUserWithoutPayment = yield* select(PaidInfoSelectors.isUserWithoutPayment);
    // исключаем бесплатников, которые никогда не платили
    if (isUserWithoutPayment) {
        return;
    }

    yield put(pastSubscriptionsRequest());
    yield handlePastSubscriptionsSuccess();

    const wasTargetSubs = yield* select((state) => PastSubscriptionsSelectors.wasSubsGreaterOrEqualThan(state, SPACE_LIST.gb_256));
    const latestSubs = yield* select(PastSubscriptionsSelectors.latestSubsByExpires);
    const latestSubsDayOffset = latestSubs ? differenceInDays(new Date(), latestSubs.expires) : 0;
    // Только бывшие платники с тарифами 256гб или больше
    if (!wasTargetSubs && latestSubsDayOffset >= 1) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.paidUserReturn,
            promoId: PAID_USER_RETURN_PROMO_ID,
            onClick: () => {
                sendPaymentGa({
                    action: 'click',
                    eventCategory: ECategoryGa.modal,
                    name: 'mnz_revert_paid_user',
                });
                emitAnalyticEvent(AnalyticEventNames.FLEXIBLE_QUOTA_PROMO_CLICK);
                closePaidUserReturnModal();
                store.dispatch(removePromo(EPromoType.paidUserReturn));
            },
            onShow: () => {
                sendPaymentGa({
                    action: 'show',
                    eventCategory: ECategoryGa.modal,
                    name: 'mnz_revert_paid_user',
                });
                emitAnalyticEvent(AnalyticEventNames.PAID_USER_RETURN_MODAL_SHOW);
                storeHelper.markAsShown(PAID_USER_RETURN_PROMO_ID);
                store.dispatch(promoShown(EPromoType.paidUserReturn));
            },
            onClose: () => {
                sendPaymentGa({
                    action: 'close',
                    eventCategory: ECategoryGa.modal,
                    name: 'mnz_revert_paid_user',
                });
                emitAnalyticEvent(AnalyticEventNames.PAID_USER_RETURN_MODAL_CLOSE);
                store.dispatch(removePromo(EPromoType.paidUserReturn));
            },
        })
    );
}

export function* showPaidUserReturnModal() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.paidUserReturn));

    if (!promo || !paidUserReturnAB.tariff) {
        return;
    }

    const { onShow, onClick, onClose } = promo;
    const { discount, year } = paidUserReturnAB.tariff;

    yield renderPaidUserReturnModal({ onShow, onClick, onClose, discount, productId: year });
}
